export default __webpack_public_path__ + "static/the-differance-is-clear-en-758346027ae9c3d068dbf667d7dd5e1f.mp4";